export { default as FadeInOut } from './FadeInOut'



// WEBPACK FOOTER //
// ./src/core/animations/index.js